import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=29273479&scoped=true&"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js&"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29273479",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29273479')) {
      api.createRecord('29273479', component.options)
    } else {
      api.reload('29273479', component.options)
    }
    module.hot.accept("./ProductSpecifications.vue?vue&type=template&id=29273479&scoped=true&", function () {
      api.rerender('29273479', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductSpecifications.vue"
export default component.exports